// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewHistory-WarningIcon_cls1__Y6XCL","cls2":"PaymentViewHistory-WarningIcon_cls2__iD0lC PaymentViewHistory-WarningIcon_cls1__Y6XCL"};